import { PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Field, Label } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";

export function KnowledgebaseCreate(props) {
  const { onCreateKnowledgebase, loading } = props;

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [label, setLabel] = useState("");

  const handleCreate = () => {
    if (label === "") {
      return;
    }

    onCreateKnowledgebase({ label });
  };

  const disableCreate = label === "";

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        <PlusIcon />
        Create Knowledge base
      </Button>
      {isOpen && (
        <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
          <DialogTitle>Create Knowledge Base</DialogTitle>
          <DialogBody>
            <div className="flex flex-col gap-y-4">
              <Field>
                <Label>Knowledge Base Name</Label>
                <Input
                  type="text"
                  value={label}
                  onChange={(e) => {
                    setLabel(e.target.value);
                  }}
                />
              </Field>
            </div>
          </DialogBody>
          <DialogActions>
            <Button outline onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button loading={loading} onClick={handleCreate} disabled={disableCreate}>
              Create
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
